import request from "@/utils/request";

export function pollenGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/Pollen/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function pollenGet(params) {
    return request({
        url: "/api/services/app/Pollen/Get",
        method: "GET",
        params
    });
}

export function pollenCreate(data) {
    return request({
        url: "/api/services/app/Pollen/Create",
        method: "post",
        data
    });
}

export function pollenCreateMany(data) {
    return request({
        url: "/api/services/app/Pollen/CreateMany",
        method: "post",
        data
    });
}

export function pollenUpdate(data) {
    return request({
        url: "/api/services/app/Pollen/Update",
        method: "put",
        data
    });
}

export function pollenSetAsDiscarded(params) {
    return request({
        url: "/api/services/app/Pollen/SetAsDiscarded",
        method: "post",
        params
    });
}

export function pollenSetManyAsDiscarded(data) {
    return request({
        url: "/api/services/app/Pollen/SetManyAsDiscarded",
        method: "post",
        data
    });
}

export function pollenDelete(params) {
    return request({
        url: "/api/services/app/Pollen/Delete",
        method: "delete",
        params
    });
}

export function pollenDeleteMany(data) {
    return request({
        url: "/api/services/app/Pollen/DeleteMany",
        method: "post",
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/pollen.js